import React, { useState } from 'react';
import { PieChart, Pie, Tooltip, Cell } from 'recharts';
import "../admin/admin.css"

const PieChartComp = () => {
    const [activeIndex, setActiveIndex] = useState(-1);

    const data = [
        { name: 'Profit', percentage: 12 },
        { name: 'Transport', percentage: 32 },
        { name: 'Marketing', percentage: 24 },
        { name: 'Cost', percentage: 42 },
    ];

    const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042'];

    const onPieEnter = (_, index) => {
        setActiveIndex(index);
    };

  return (
    <PieChart width={200} height={200}>
            <Pie
                activeIndex={activeIndex}
                data={data}
                dataKey="percentage"
                outerRadius={100}
                innerRadius={40}
                fill="green"
                onMouseEnter={onPieEnter}
                style={{ cursor: 'pointer', outline: 'none' }} // Ensure no outline on focus
            >
                {data.map((entry, index) => (
                    <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                ))}
            </Pie>
            <Tooltip />
        </PieChart>
  )
}

export default PieChartComp